import React from 'react'
import PropTypes from 'prop-types'

import Accordion from '../../components/Accordion'
import RangeSlider from '../rangeSlider'

const UnsortedList = (props) => {
  const { name, values, selectedValues, handleFilterClick, isMobile, expanded } = props

  const headerText = name.includes('.') ? name.split('.')[1] : name

  const handleSliderFacet = ({ minValue, maxValue }) => {
    handleFilterClick({
      min: minValue,
      max: maxValue,
      name,
    })
  }

  return (
    values.min !== values.max && (
      <Accordion title={headerText} isMobile={isMobile} expanded={expanded}>
        <RangeSlider
          prefix="$"
          min={values.min}
          max={values.max}
          defaultMin={selectedValues.min}
          defaultMax={selectedValues.max}
          unboundedMax={false}
          stepSize={1000}
          onChange={handleSliderFacet}
        />
      </Accordion>
    )
  )
}

export default UnsortedList

UnsortedList.defaultProps = {
  isMobile: false,
  expanded: true,
}

UnsortedList.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  selectedValues: PropTypes.object,
  handleFilterClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  expanded: PropTypes.bool,
}
